import React, { FunctionComponent, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAuth } from 'hooks';
import OrganizationMarketplacesFilter from 'components/Bookings2/List/OrganizationMarketplacesFilter';
import useOrganizationMarketplaces from 'hooks/useOrganizationMarketplaces';

export interface DashboardProps {
    onGotoTransactions: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'block',
            justifyContent: 'center',
            background: 'white',
            height: '99%',
            width: '100%'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '70px',
            padding: '0px 10px'
        },
        title: {
            fontSize: 24,
            fontWeight: 600,
            paddingTop: 5
        },
        iframe: {
            width: '100%',
            border: 'none',
            height: 'calc(100% - 70px)'
        }
    })
);

export const Dashboard: FunctionComponent<DashboardProps> = props => {
    const classes = useStyles();

    const auth = useAuth();
    const { organizationMarketplaces } = useOrganizationMarketplaces();

    const [selectedMarketplaceId, setSelectedMarketplaceId] = useState(auth.marketplaceId ?? 0);

    const url = `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_WEB_BASE_URL}payments_dashboard?access_token=${auth.token}&marketplace_id=${auth.marketplaceId}&marketplace_ids=${selectedMarketplaceId}`;

    const messageHandler = (event: MessageEvent) => {
        const action: string | undefined = event.data.action;
        if (action === 'goto_transactions') {
            props.onGotoTransactions && props.onGotoTransactions();
        }
    };

    useEffect(() => {
        window.addEventListener('message', messageHandler);
        return () => {
            window.removeEventListener('message', messageHandler);
        };
    }, []);

    const header = (
        <div className={classes.header}>
            <span className={classes.title}>Dashboard</span>
            {organizationMarketplaces.length > 1 && (
                <OrganizationMarketplacesFilter
                    singleSelection={true}
                    selected={[selectedMarketplaceId]}
                    onChangeSelection={([marketplaceId]) => setSelectedMarketplaceId(marketplaceId)}
                />
            )}
        </div>
    );

    return (
        <Box className={classes.container}>
            {header}
            <iframe
                title="Payments Dashboard"
                className={classes.iframe}
                src={url}
            ></iframe>
        </Box>
    );
};

export default Dashboard;
